/**
 * @fileoverview POST handler for the "/recently_visited/visit" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { recentlyVisitedVisitCacheKeys } from "./constants";
import type { PostRecentlyVisitedVisitProps, RecentlyVisitedVisitResult } from "./types";

export const postRecentlyVisitedVisit = reactQueryMutationAdapter(
  recentlyVisitedVisitCacheKeys,
  (props: PostRecentlyVisitedVisitProps): Promise<RecentlyVisitedVisitResult> => {
    return fetch("/recently_visited/visit", "POST", props);
  }
);
